import BsTextarea from './index.vue'
export default BsTextarea